import { ReactSimpleComponentProps } from '@/custom-types'
import {
  AddInsuranceFormModalContext,
  AddInsuranceFormModalContextProps,
} from './AddInsuranceFormModalContext'
import { InsuranceOutput } from '@/graphql/generated'
import { useMemo, useRef, useState } from 'react'

export const AddInsuranceFormModalContextProvider = ({ children }: ReactSimpleComponentProps) => {
const insuranceRef = useRef<InsuranceOutput | null>(null)
  const [isOpen, setOpen] = useState(false)

  const actions = useMemo<Omit<AddInsuranceFormModalContextProps, 'insuranceData' | 'isOpen'>>(() => ({
    closeModal: () => {
      setOpen(false)
      insuranceRef.current = null
    },

    openModal: (insuranceData?: InsuranceOutput) => {
      setOpen(true)

      if (insuranceData) insuranceRef.current = insuranceData
    }
  }), [])

  return (
    <AddInsuranceFormModalContext.Provider value={{ ...actions, isOpen, insuranceData: insuranceRef.current}}>
      {children}
    </AddInsuranceFormModalContext.Provider>
  )
}